export const iconFontAwesomeTransportationTruckPlane = (
	<i className="fa-solid fa-truck-plane"></i>
);
